export default __webpack_public_path__ + "static/media/clown.c108b398.png";